import logEvent from "lib/ga/miscEvent";
import logSearchPageFilter from "lib/ga/searchPageFilter";
import TEXT from "localisation";
import { useState, useEffect, useRef, KeyboardEvent } from 'react';
import styles from './advancedFilters.module.css';

const googleEvents = (location: string, value: object, filterLabel: string) => {
    logEvent({
        category: "Flexible Search",
        action: "Filter Applied",
        label: `Location: ${location}, Filter: ${filterLabel}, Value: ${JSON.stringify(value)}`,
    });

    logSearchPageFilter({
        filter: filterLabel,
        value: JSON.stringify(value),
        state: "add",
    });
}

type PageProps = {
    label: string,
    options: any,
    values: any,
    onSelect: any,
    onRemove: any,
    location: string,
    border: boolean,
    lableLookUp: string,
};

const CheckboxFiliter = ({ label, options, values, onSelect, onRemove, border, lableLookUp, location }: PageProps) => {

    const [unselectedOptions, setUnselectedOptions] = useState(options.sort((a, b) => a.value.toLowerCase().localeCompare(b.value.toLowerCase())));

    const handleChange = (e) => {
        const newValue = values;
        const index = values.indexOf(e);
        if (index > -1) {
            values.splice(index, 1);
            onRemove(e);
            googleEvents(location, newValue, label);
        } else {
            newValue.push(e)
            onSelect(e);
            googleEvents(location, newValue, label);
        }
    }

    const handleSearch = (e) => {
        let finishedOptions: any = []
        options.forEach(element => {
            let txtValue = element.value;
            if (txtValue.toUpperCase().indexOf(e.toUpperCase()) > -1) {
                finishedOptions.push(element)
            }
        })

        setUnselectedOptions(finishedOptions);
    }


    const [dropdownShow, setDropdownShow] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef?.current?.contains(event.target)) {
                setDropdownShow(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    const unSelected = options.filter(x => x.selected);

    return (
        <>
            <div className={styles.searchContainer} ref={wrapperRef}>
                <div className={styles.dropdownButtonOuter}> <button className={styles.dropdownButton} onClick={(e) => {
                    setDropdownShow(!dropdownShow)
                }}>Name</button> </div>
                <div className={dropdownShow ? `${styles.show} ${styles.searchSuggestions}` : `${styles.hide} ${styles.searchSuggestions}`} >
                    <input
                        className={styles.searchInput} type="text" placeholder="Search.." onKeyUp={
                            (e: KeyboardEvent<HTMLInputElement>) => {
                                handleSearch(e.currentTarget.value)
                            }
                        } />

                    {unselectedOptions.filter(x => !x.selected).map((option, index) => (
                        <div
                            className={styles.searchItem}
                            key={option.value}
                            onClick={() => {
                                handleChange(option.value)
                            }}
                        >{lableLookUp ? TEXT[`${lableLookUp}${option.value}`] : option.value} {unSelected.find(e => e.value === option.value) && (<span>x</span>)}</div>
                    ))}
                </div>
            </div>
            <div>
                {options.filter(x => x.selected).map((option) => (
                    <button className={styles.searchPill} key={option.value} onClick={() => {
                        handleChange(option.value)
                    }}>{option.value}  <span>x</span></button>
                ))}
            </div>
        </>
    )
}


export default CheckboxFiliter;






